// extracted by mini-css-extract-plugin
export var blue = "_13-f";
export var brand = "_13-b";
export var darkGrey = "_13-e";
export var disabled = "_13-4";
export var disabledSubtle = "_13-5";
export var error = "_13-6";
export var green = "_13-g";
export var grey = "_13-d";
export var icon = "_13-0";
export var inherit = "_13-a";
export var lightGrey = "_13-c";
export var orange = "_13-i";
export var pink = "_13-k";
export var primary = "_13-1";
export var purple = "_13-l";
export var red = "_13-j";
export var secondary = "_13-2";
export var success = "_13-9";
export var tertiary = "_13-3";
export var warning = "_13-7";
export var warningSecondary = "_13-8";
export var white = "_13-m";
export var yellow = "_13-h";